import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ModuleUserPermissions } from 'app/library/module-user/enums/module-user-permissions.enum';
import { ModuleManagerPermissions } from 'app/library/module-user/models/module-manager-permissions';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-edit-manager-permissions-dialog',
    templateUrl: './edit-manager-permissions-dialog.component.html',
    styleUrls: ['./edit-manager-permissions-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EditManagerPermissionsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    title: string;

    @Input()
    selectedPermissions: string[] = [];

    get permissionsFormArray(): FormArray {
        return this.formGroup.get('permissions') as FormArray;
    }

    getSelectedPermissions(): ModuleUserPermissions[] {
        return this.permissionsFormArray.controls
            .map((control, i) => (control.value ? this.moduleManagerPermissions.all[i].value : null))
            .filter((value): value is ModuleUserPermissions => value !== null);
    }

    moduleManagerPermissions = ModuleManagerPermissions;
    formGroup: FormGroup;

    constructor(public dialogRef: MatDialogRef<EditManagerPermissionsDialogComponent>, private fb: FormBuilder) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.formGroup = this.fb.group({
            permissions: this.fb.array(this.moduleManagerPermissions.all.map((permission) => new FormControl(this.selectedPermissions.includes(permission.value)))),
        });
    }

    saveSelected(): void {
        this.dialogRef.close({
            data: {
                permissions: this.getSelectedPermissions(),
            },
        });
    }
}
